(function(){
    const $masonryGrids = document.querySelectorAll('.masonry-grid')
    $masonryGrids.forEach(async ($mg) => {
        const {Masonry} = await import(/* webpackChunkName: "masonryIsotope" */'./Masonry')
        new Masonry.ScatteredIsotope($mg)
    })
})()